/**
 * «Определить местоположение» (рядом с «Обновить GPS» в шапке, §2.2.1):
 * живой опрос, МИМО очереди (как unlock/lock — см. `api/device.ts`), плюс
 * бейдж режима слежения, пока сервер держит на замке частый GPS.
 *
 * Компонент чисто презентационный: весь опрос и вся его логика — в
 * `useLocateTracking` (`api/device.ts`), вызванном на уровне `bike-card.tsx`
 * (не здесь, ЧТОБЫ ОСТАЛСЯ РОВНО ОДИН ВЫЗОВ `applyDeviceReading` НА
 * КАРТОЧКУ — второй, независимый источник «текущего» состояния устройства
 * внутри самодостаточного компонента незаметно разошёлся бы с шапкой).
 *
 * ⚠ МИНИ-КАРТА СЛЕЖЕНИЯ — НЕ ЗДЕСЬ. Она рисуется в `bike-card.tsx` тем же
 * лениво загруженным `MiniMap`, что и «История»: второй `lazy()`-обёртки на
 * тот же модуль заводить незачем.
 */
import { commandBlockedReason } from '@/api/device'
import { BigButton, Notice } from '@/components/ui'

export function BikeLocate({
  vehicleId,
  online,
  onStart,
  starting,
  error,
  active,
  secondsLeft,
  satellites,
  pointAgoText,
  onStop,
}: {
  vehicleId: string
  online: boolean
  onStart: () => void
  /** Идёт POST /locate. */
  starting: boolean
  /** Текст отказа последнего опроса, либо null. */
  error: string | null
  /** Идёт режим слежения — показывать бейдж и «Стоп». */
  active: boolean
  secondsLeft: number
  satellites: number
  /** «точка N с назад» либо null, если ответа ещё не было. */
  pointAgoText: string | null
  onStop: () => void
}) {
  const blocked = commandBlockedReason(online, vehicleId)

  return (
    <section className="mb-4">
      {blocked ? (
        <div className="mb-2">
          <Notice tone="warn">{blocked}</Notice>
        </div>
      ) : null}

      <BigButton tone="neutral" disabled={!!blocked} busy={starting} onClick={onStart}>
        Определить местоположение
      </BigButton>

      {error ? (
        <div className="mt-2">
          <Notice tone="error">{error}</Notice>
        </div>
      ) : null}

      {active ? (
        <div
          className="mt-2 flex items-center justify-between gap-2 rounded-lg bg-white/5 px-3
            py-2 text-xs opacity-80"
        >
          <span>
            Слежение: {secondsLeft} с · спутники {satellites} ·{' '}
            {pointAgoText ?? 'точка ещё не пришла'}
          </span>
          <button
            type="button"
            onClick={onStop}
            className="min-h-11 shrink-0 rounded-lg border border-white/20 px-3 text-xs
              font-medium"
          >
            Стоп
          </button>
        </div>
      ) : null}
    </section>
  )
}
